import React from 'react'
import PropTypes from 'prop-types'
import { Form } from 'react-bootstrap'

import styles from './styles.module.scss'

const FormCheck = ({
  controlId,
  error,
  inputRef,
  label = '',
  ...rest
}) => {
  const hasError = !!error
  return (
    <Form.Group controlId={controlId}>
      <Form.Check
        ref={inputRef}
        isInvalid={hasError}
        className={`${styles.formCheck} mb-10`}
        label={label}
        {...rest}
      />
      {hasError && (
        <small className="text-danger">{error.message}</small>
      )}
    </Form.Group>
  )
}

FormCheck.propTypes = {
  controlId: PropTypes.string.isRequired,
  error: PropTypes.object,
  inputRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.object
  ]),
  label: PropTypes.string
}

export default FormCheck
